export default {
  allPrivateWorkspaces: (state:any) => {
    const allWorkspaces = state.user.workspaces || []
    return allWorkspaces.filter((workspace:any)=>workspace.type==='private')
  },
  allWorkspacesObject: (state:any) => {
    return state.user?.workspaces?.reduce((acc, item) => {
      acc[item.id] = item
      return acc
    }, {}) || {}
  },
  allPublicWorkspacesIds: (state:any) => {
    const allWorkspaces = state.user.workspaces || []
    const allWorkspacesFiltered = allWorkspaces.filter((workspace:any)=>workspace.type==='public')
    return allWorkspacesFiltered.map((workspace:any)=>workspace.id)
  }
};